export default {
  moistureContent: {
    BS_EN_ISO_17892_1: { rev2014: '110479' },
  },
  atterbergLimit: {
    BS_EN_ISO_17892_12_2018: {
      rev2018_2022_methodA: '110482',
      rev2018_2022_methodB: '110483',
      plastic_limit_standalone: '110528',
    },
  },
  hydrometer: {
    BS_EN_ISO_17892_4_Clause_5_3: { Rev2016: '110959' },
  },
  psdSieveAnalysis: {
    BS_EN_ISO_17892_4_Clause_5_2: { Rev2016: '110957' },
  },
  wash: {
    BS_EN_ISO_17892_4_Clause_5_2: { Rev2016: '110958' },
    BS_EN_ISO_17892_4_Clause_5_3: { Rev2016: '110962' },
  },
};
